import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, FloatingLabel, Spinner } from 'react-bootstrap';
import Styles from '../../styles/authentication/signup.module.css';
import { FaEyeSlash, FaEye } from 'react-icons/fa';
import { SignupHelper } from '../../helpers/auth/signup-helper';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { Helmet } from 'react-helmet';

const SignUp: React.FC = () => {
  const {
    formErrors,
    values,
    handleSignup,
    handleChange,
    isProcessing,
  } = SignupHelper();

  const navigate = useNavigate();

  // password show and hide
  const [showPassword, setShowPassword] = useState(false);

  // Separate states for each label's active state
  const [nameActive, setNameActive] = useState(false);
  const [userActive, setUserActive] = useState(false);
  const [emailActive, setEmailActive] = useState(false);
  const [passActive, setPassActive] = useState(false);
  const [numActive, setNumActive] = useState(false);

  // handle the show and hide password functionality
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>

      {/* Cursor Effect */}
      {/* <div
        className={`${Styles.cursor} ${cursorGrowing ? Styles.growing : ''}`}
        style={{
          top: `${cursorPosition.y}px`,
          left: `${cursorPosition.x}px`,
        }}
      ></div> */}
      <Helmet>
        <title>Sign Up - Mohit's Shopping App</title>
        <meta
          name="description"
          content="Join Mohit's Shopping App and enjoy exclusive member benefits, personalized recommendations, and the latest offers. Sign up now to start your shopping journey!"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta property="og:title" content="Sign Up - Mohit's Shopping App" />
        <meta
          property="og:description"
          content="Become a member of Mohit's Shopping App. Sign up for access to exclusive deals, discounts, and much more!"
        />
        <meta
          property="og:image"
          content={`${process.env.PUBLIC_URL}/favicon.png`}
        />
        <meta
          property="og:url"
          content="https://mohit-online-shopping.netlify.app/sign-up"
        />
      </Helmet>

      {/* Main Heading of the Sign Up Page */}
      <h1 className="visually-hidden">Sign Up - Join Mohit's Shopping App for Exclusive Deals</h1>

      <section className={Styles.signupsec}>
        <Container fluid className={Styles.container}>
          <Row className={`justify-content-left ${Styles.row}`}>
            <Col className={`d-flex align-items-center justify-content-center ${Styles.col}`} md={6}>
              <Box className={Styles.formWrapper}>
                <h1>Create Account</h1>
                <Form onSubmit={handleSignup}>
                  <Form.Group>
                    <FloatingLabel
                      controlId="floatingInput"
                      label="Your Name"
                      className={`${Styles.floatingLabel} ${nameActive ? Styles.floatingLabelActive : ''}`}
                    >
                      <Form.Control
                        type="text"
                        placeholder="Your Name"
                        name="name"
                        className={Styles.input}
                        autoComplete="off"  // Use camelCase for JSX
                        onFocus={() => setNameActive(true)}
                        onBlur={(e) => setNameActive(e.target.value !== '')}
                        value={values.name}
                        onChange={handleChange}
                        disabled={isProcessing} // Disable when processing
                      />
                    </FloatingLabel>
                  </Form.Group>
                  <Form.Group>
                    <FloatingLabel
                      controlId="floatingInput"
                      label="User Name"
                      className={`${Styles.floatingLabel} ${userActive ? Styles.floatingLabelActive : ''}`}
                    >
                      <Form.Control
                        type="text"
                        placeholder="User Name"
                        name="username"
                        className={Styles.input}
                        autoComplete="off"  // Use camelCase for JSX
                        onFocus={() => setUserActive(true)}
                        onBlur={(e) => setUserActive(e.target.value !== '')}
                        value={values.username}
                        onChange={handleChange}
                        // Set an unconventional value
                        disabled={isProcessing} // Disable when processing
                      />
                    </FloatingLabel>
                  </Form.Group>
                  <Form.Group>
                    <FloatingLabel
                      controlId="floatingInput"
                      label="Your Email"
                      className={`${Styles.floatingLabel} ${emailActive ? Styles.floatingLabelActive : ''}`}
                    >
                      <Form.Control
                        type="email"
                        placeholder="Email"
                        name="email"
                        className={Styles.input}
                        autoComplete="off"  // Use camelCase for JSX
                        onFocus={() => setEmailActive(true)}
                        onBlur={(e) => setEmailActive(e.target.value !== '')}
                        value={values.email}
                        onChange={handleChange}
                        disabled={isProcessing} // Disable when processing
                      />
                    </FloatingLabel>
                  </Form.Group>
                  <Form.Group>
                    <FloatingLabel
                      controlId="floatingInput"
                      label="Your Phone No."
                      className={`${Styles.floatingLabel} ${numActive ? Styles.floatingLabelActive : ''}`}
                    >
                      <Form.Control
                        type="phone"
                        placeholder="Phone"
                        name="phone"
                        className={Styles.input}
                        autoComplete="off"  // Use camelCase for JSX
                        onFocus={() => setNumActive(true)}
                        onBlur={(e) => setNumActive(e.target.value !== '')}
                        value={values.phone}
                        onChange={handleChange}
                        disabled={isProcessing} // Disable when processing
                      />
                    </FloatingLabel>
                  </Form.Group>
                  <Form.Group>
                    <FloatingLabel
                      controlId="floatingInput"
                      label="Create Password"
                      className={`${Styles.floatingLabel} ${passActive ? Styles.floatingLabelActive : ''}`}
                    >
                      <Form.Control
                        type={showPassword ? 'text' : 'password'}
                        placeholder="Password"
                        name="password"
                        className={Styles.input}
                        autoComplete="off"  // Use camelCase for JSX
                        onFocus={() => setPassActive(true)}
                        onBlur={(e) => setPassActive(e.target.value !== '')}
                        value={values.password}
                        onChange={handleChange}
                        disabled={isProcessing} // Disable when processing
                      />
                      <div
                        onClick={togglePasswordVisibility}
                        className={Styles.authToggleBtn}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </div>
                    </FloatingLabel>
                  </Form.Group>
                  <Button
                    disabled={isProcessing}
                    type="submit"
                    className={Styles.signupBtn}>
                    {Object.keys(formErrors).length > 0 ? (
                      'Sign Up'
                    ) : isProcessing ? (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className={Styles.customSpinner} // Applying custom spinner styles here
                      />
                    ) : (
                      'Sign Up'
                    )}
                  </Button>
                  <div className={Styles.text}>
                    Already have an account?
                    <b className={Styles.pointer} onClick={() => navigate('/auth/sign-in')}> Sign in here</b>
                  </div>
                </Form>
              </Box>
            </Col>
            {/* use in future */}
            {/* <Col className={`d-none d-md-flex align-items-center justify-content-center ${Styles.col}`} md={6}>
              <div className={Styles.backgroundText}>
                <h2>Join with us</h2>
              </div>
            </Col> */}
          </Row>
        </Container>
      </section>
    </>
  );
};

export default SignUp;
